import { store } from 'v3/data/store';
import { storesSlice } from 'v3/data/store/stores';
import { PERMISSIONS } from './constants';
import { IPermission, IStoreGroup, IStoreItem, IStoreLogged, IStoreSelected, IStoresList } from './types';

export const setStoreSelected = (storeSelected: IStoreSelected) => {
  store.dispatch(storesSlice.actions.setStoreSelected(storeSelected));
};

export const clearStoreSelected = () => {
  store.dispatch(storesSlice.actions.clearStoreSelected());
};

export const setStoreLogged = (storeLogged: IStoreLogged) => {
  store.dispatch(storesSlice.actions.setStoreLogged(storeLogged));
};

export const getStorePermissions = (): IPermission => {
  const { group } = store.getState().store.storeLogged;
  return PERMISSIONS[group];
};

export const setStoreList = (storeList: IStoreItem[]) => {
  store.dispatch(storesSlice.actions.setStoreList(storeList));
};

export const restoreStoreList = (storeList: IStoreItem[]) => {
  const defaultCheckedList = storeList.map((item) => {
    return {
      ...item,
      checked: true,
    };
  });
  setStoreList(defaultCheckedList);
};

export const setAllStoreList = (stores: IStoresList) => {
  store.dispatch(storesSlice.actions.setAllStoreList(stores));
};

export const setFilterSearchStore = (searchStore: string) => {
  store.dispatch(storesSlice.actions.setFilterSearchStore(searchStore));
};

export const setFilterCurrentPage = (page: number) => {
  store.dispatch(storesSlice.actions.setFilterCurrentPage(page));
};

export const setFilterRowsPerPage = (rowsPerPage: number) => {
  store.dispatch(storesSlice.actions.setFilterRowsPerPage(rowsPerPage));
};

export const clearAllFilters = () => {
  store.dispatch(storesSlice.actions.clearFilters());
};

export const setStoreGroupList = (storeGroups: IStoreGroup[]) => {
  store.dispatch(storesSlice.actions.setStoreGroupList(storeGroups));
};

export const setStoreGroupSelected = (storeGroups: Partial<IStoreGroup>) => {
  store.dispatch(storesSlice.actions.setStoreGroupSelected(storeGroups));
};
